
namespace Matrix.Rebalancer {

    @Serenity.Decorators.registerClass()
    export class TaskTypeGrid extends SiteEntityGrid<TaskTypeRow, any> {
        protected getColumnsKey() { return 'Rebalancer.TaskType'; }
        protected getDialogType() { return TaskTypeDialog; }
        protected getIdProperty() { return TaskTypeRow.idProperty; }
        protected getLocalTextPrefix() { return TaskTypeRow.localTextPrefix; }
        protected getService() { return TaskTypeService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}